var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ring-top"},[_c('div',{staticClass:"calendar-ring"},[_c('div',{staticClass:"ring"}),_vm._v(" "),_c('div',{staticClass:"ring"})]),_vm._v(" "),_c('div',{staticClass:"calendar-ring"},[_c('div',{staticClass:"ring"}),_vm._v(" "),_c('div',{staticClass:"ring"})])])
}]

export { render, staticRenderFns }